/**
 * Source and layer ids shared between the map hooks.
 *
 * Kept in a module of their own rather than on the hook that creates them so that a hook which
 * only needs to NAME a layer -- to query it, or to stand aside for it -- does not have to
 * import the one that draws it, and with it maplibre-gl itself. The draft-lasso ids stay on
 * useTerritoryDraw, which is the only thing that touches them.
 */

/**
 * Pins. The active (hovered/clicked) pin is drawn on its own overlay source/layer that sits ON
 * TOP of the contact-pins layer, so hover never re-lays-out the pins around it. See SH-824.
 */
export const CONTACT_PINS_SOURCE = 'contact-pins'
export const CONTACT_PINS_LAYER = 'contact-pins-layer'
export const ACTIVE_PIN_SOURCE = 'active-pin'
export const ACTIVE_PIN_LAYER = 'active-pin-layer'

/** D2D sales territories (WWM-17508). */
export const TERRITORY_SOURCE = 'territory-boundaries'
export const TERRITORY_FILL_LAYER = 'territory-fill'
export const TERRITORY_LINE_LAYER = 'territory-line'
